import { FC } from 'react';

// Components
import WinnerBadge from './WinnerBadge';

// Utils
import { classNames } from '@sportal365/smp-widget-utils';

// Types
import { INormalizedTeamV2 } from '../../../../../../packages/types';

interface Props {
  homeTeam: INormalizedTeamV2;
  awayTeam: INormalizedTeamV2;
}

const MatchParticipantsVertical: FC<Props> = ({ homeTeam, awayTeam }) => {
  const isScoreEven = homeTeam.score === awayTeam.score;
  const isHomeTeamWinner = homeTeam.score > awayTeam.score;
  const isAwayTeamWinner = awayTeam.score > homeTeam.score;

  return (
    <div className='match-participants-vertical-container py-4 pr-4'>
      <div className='home-team-container flex justify-between items-center pb-1'>
        <div className='home-team-information flex justify-end items-center gap-2'>
          <img src={homeTeam.logo} className='home-team-logo h-6 w-6' />
          <p
            className={classNames({
              'home-team-name m-0 text-4 text-hiContrast text-ellipsis whitespace-pre overflow-hidden max-w-[170px] sm:max-w-none': true,
              'font-bold': homeTeam.isWinner,
            })}
          >
            {homeTeam.name}
          </p>
          {homeTeam.winnerReason ? <WinnerBadge text={homeTeam.winnerReason} /> : null}
        </div>
        <span
          className={classNames({
            'home-team-score text-4': true,
            'text-hiContrast': homeTeam.isWinner || isScoreEven || isHomeTeamWinner,
            'font-bold': homeTeam.isWinner || isHomeTeamWinner,
            'text-[#8c8c8c]': !isScoreEven && !isHomeTeamWinner && !homeTeam.isWinner,
          })}
        >
          {homeTeam.score}
        </span>
      </div>
      <div className='away-team-container flex justify-between items-center pt-1'>
        <div className='away-team-information flex justify-start items-center gap-2'>
          <img src={awayTeam.logo} className='away-team-logo h-6 w-6' />
          <p
            className={classNames({
              'away-team-name m-0 text-4 text-hiContrast text-ellipsis whitespace-pre overflow-hidden max-w-[170px] sm:max-w-none': true,
              'font-bold': awayTeam.isWinner,
            })}
          >
            {awayTeam.name}
          </p>
          {awayTeam.winnerReason ? <WinnerBadge text={awayTeam.winnerReason} /> : null}
        </div>
        <span
          className={classNames({
            'away-team-score text-4': true,
            'text-hiContrast': awayTeam.isWinner || isScoreEven || isAwayTeamWinner,
            'font-bold': awayTeam.isWinner || isAwayTeamWinner,
            'text-[#8c8c8c]': !isScoreEven && !isAwayTeamWinner && !awayTeam.isWinner,
          })}
        >
          {awayTeam.score}
        </span>
      </div>
    </div>
  );
};

export default MatchParticipantsVertical;
